import { Flex, FlexItem, Title } from '@patternfly/react-core';
import Avatar from './Avatar';
import Notifications from './Notifications';
import { useNavigate } from 'react-router-dom';
import React from 'react';

type Props = {
	headerText: string;
};

export default function HeaderContent(props: Props) {
	const navigate = useNavigate();

	return (
		<Flex
			justifyContent={{ default: 'justifyContentSpaceBetween' }}
			alignItems={{ default: 'alignItemsCenter' }}
		>
			<FlexItem>
				<Title headingLevel={'h3'}>{props.headerText}</Title>
			</FlexItem>
			<FlexItem>
				<Flex>
					<FlexItem>
						<Notifications onClick={() => navigate('/notifications')} />
					</FlexItem>
					<FlexItem>
						<Avatar />
					</FlexItem>
				</Flex>
			</FlexItem>
		</Flex>
	);
}
